export const extractUserFromAuthState = (authState) => {
  if (!authState.idToken || !authState.accessToken) {
    return null;
  }
  const idTokenClaims = authState.idToken.claims;
  const accessTokenClaims = authState.accessToken.claims;
  return {
    name: idTokenClaims.name,
    email: idTokenClaims.email,
    groups:
      accessTokenClaims?.groups?.length > 0
        ? [...accessTokenClaims.groups]
        : [],
  };
};
